import { getJSON } from 'bv-fetch';
import { logged_in as loggedIn } from 'state';

const fetchSections = () => getJSON(`/api/site_navigation/top_navigation?l=${loggedIn()}`);

export default fetchSections;
